export default __webpack_public_path__ + "static/media/teamsIcon-filled.e35f81f1.svg";